var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuredocDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161730",
    "data-name": "Group 161730",
    transform: "translate(-0.023 -0.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    width: 23,
    height: 23,
    rx: 4,
    transform: "translate(0.023 0.205)",
    fill: "#f4cefb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "date-today-svgrepo-com",
    transform: "translate(5.511 5.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M3,8.662C3,7.407,3,6.78,3.39,6.39S4.407,6,5.662,6h6.654c1.255,0,1.882,0,2.272.39s.39,1.017.39,2.272v.665H3Z",
    transform: "translate(-3 -4.004)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    width: 12,
    height: 10,
    rx: 2,
    transform: "translate(0.023 2)",
    fill: "none",
    stroke: "#222",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M7,3V6.327",
    transform: "translate(-4.338 -3)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M17,3V6.327",
    transform: "translate(-7.685 -3)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocDateIcon);
export default __webpack_public_path__ + "static/media/securedoc-date-icon.2523e90cd0c70aac8075552cc608742d.svg";
export { ForwardRef as ReactComponent };